import styled from 'styled-components';

const ListPannel = styled.div``;

export const Style = { ListPannel };
